import { useRef, useState } from "react";

/** Draggable before-after slider. */
export default function BeforeAfterSlider({
  beforeSrc,
  afterSrc,
  alt,
  testId = "before-after",
}) {
  const [pos, setPos] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const setFromClient = (clientX) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    setPos((x / rect.width) * 100);
  };

  return (
    <div
      ref={containerRef}
      data-testid={testId}
      className="relative overflow-hidden select-none aspect-[16/10] border border-charcoal"
      onMouseDown={(e) => {
        dragging.current = true;
        setFromClient(e.clientX);
      }}
      onMouseMove={(e) => dragging.current && setFromClient(e.clientX)}
      onMouseUp={() => (dragging.current = false)}
      onMouseLeave={() => (dragging.current = false)}
      onTouchStart={(e) => {
        dragging.current = true;
        setFromClient(e.touches[0].clientX);
      }}
      onTouchMove={(e) => dragging.current && setFromClient(e.touches[0].clientX)}
      onTouchEnd={() => (dragging.current = false)}
    >
      <img
        src={afterSrc}
        alt={`${alt} — after`}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div
        className="absolute inset-0 overflow-hidden"
        style={{ width: `${pos}%` }}
      >
        <img
          src={beforeSrc}
          alt={`${alt} — before`}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ width: `${100 / (pos / 100)}%`, maxWidth: "none" }}
        />
        <span className="absolute top-4 left-4 text-eyebrow font-display font-bold uppercase tracking-[0.22em] text-emerald bg-ink/70 px-2 py-1">
          BEFORE
        </span>
      </div>
      <span className="absolute top-4 right-4 text-eyebrow font-display font-bold uppercase tracking-[0.22em] text-white bg-ink/70 px-2 py-1">
        AFTER
      </span>

      <div
        className="absolute top-0 bottom-0 w-px bg-emerald"
        style={{ left: `${pos}%` }}
      >
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-emerald text-ink grid place-items-center cursor-ew-resize shadow-2xl">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M8 5l-5 7 5 7M16 5l5 7-5 7" />
          </svg>
        </div>
      </div>
    </div>
  );
}
